import { render, staticRenderFns } from "./step_4.vue?vue&type=template&id=71cc5d98&scoped=true&lang=pug&"
import script from "./step_4.vue?vue&type=script&lang=js&"
export * from "./step_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc5d98",
  null
  
)

export default component.exports